import React, { useCallback } from 'react';
import scssVariables from 'styles/variables.scss';
import AccessibleDiv from 'components/AccessibleDiv/AccessibleDiv';
import Icon from 'components/Icon';
import { IconType } from 'components/Icon/constants';
import { intlGet } from 'utils/intlGet';
import styles from './styles.module.scss';

type Props<T> = {
  active: boolean;
  disabled?: boolean;
  label: IconType;
  onToggle: (value: T) => void;
  value: T;
  title: string;
  dataTestId?: string;
};

export default function EditorToolbarButton<T=string>(props: Readonly<Props<T>>): JSX.Element {
  const {
    active,
    disabled = false,
    title,
    label,
    value,
    onToggle,
    dataTestId = 'editorToolbarButton',
  } = props;

  const toggleHandler = useCallback((event: React.SyntheticEvent<EventTarget>): void => {
    event.preventDefault();
    onToggle(value);
  }, [onToggle, value]);

  return (
    <AccessibleDiv
      className={styles.editorToolbarButton}
      data-title={title}
      onMouseDown={disabled ? undefined : toggleHandler}
      data-testid={dataTestId}
    >
      <Icon
        type={label}
        size="badge"
        color={active ? 'primary' : 'secondary'}
        isDisabled={disabled}
        disableColor={scssVariables.mediumGrey}
        hoverColor="primary-hover"
        hoverTooltipText={intlGet('EditorToolbar.Tooltip', label)}
      />
    </AccessibleDiv>
  );
}
